export class BlockPaymentModel {
  constructor(
    public id: number,
    public value: boolean
  ) {
  }
}
